var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.estateForDocument.name)?_c('span',{staticClass:"caption font-weight-bold"},[_vm._v("\n  "+_vm._s(_vm.estateForDocument.name)+" ("+_vm._s(_vm.estateForDocument.socialSecurityNumber)+")\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }